"use strict";
/**
 * Dispatch `stateChange` event every time the 'checked' value is changed externally via javascript.
 * Purpose is to notify the gui that the internal element was changed, and the gui needs to be updated.
 */
(function wrapper(propertyDescriptor) {
    // overwrite the `checked` descriptor with our own
    Object.defineProperty(HTMLInputElement.prototype, 'checked', {
        set(newState) {
            /* istanbul ignore if */
            if (propertyDescriptor === undefined || propertyDescriptor.set === undefined) {
                return;
            }
            // check the current `checked` state
            const prevState = this.checked;
            // call the original descriptor to update the HTMLInputElement
            propertyDescriptor.set.call(this, newState);
            // send `stateChange` event when and only when the state actually changed
            if (prevState !== newState) {
                this.dispatchEvent(new Event('stateChange', { bubbles: true, cancelable: true }));
            }
        }
    });
}(Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked')));
//# sourceMappingURL=StateChange.js.map